import { render, staticRenderFns } from "./ProjectCollapseServices.vue?vue&type=template&id=039b27df&scoped=true"
import script from "./ProjectCollapseServices.vue?vue&type=script&lang=ts"
export * from "./ProjectCollapseServices.vue?vue&type=script&lang=ts"
import style0 from "./ProjectCollapseServices.vue?vue&type=style&index=0&id=039b27df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039b27df",
  null
  
)

export default component.exports